<template>
  <div>
    <THeading
      :level="3"
      tag="h2"
      class="mb-6"
    >
      {{ title }}
    </THeading>

    <div class="grid grid-cols-2 md:grid-cols-4 gap-8">
      <TMarketingCard
        v-for="park in parks"
        :key="park.Id"
        :title="park.Name ?? ''"
        :subtitle="park.Region ?? ''"
        :image="{
          src: getImageUrl(park.Images?.[0]?.Path),
          alt: park.Images?.[0]?.AltText || (park.Name ?? ''),
        }"
        :to="localePath({ name: ROUTE_BASE_NAME.rv_rentals_park, params: { parkSlug: park.Slug } })"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Park } from '~/types/rental-api-aliases'
import { ROUTE_BASE_NAME } from '~/constants'

defineProps<{
  title: string
  parks: Park[]
}>()

const localePath = useLocalePath()
const { getStaticImage, presets } = useImage()

function getImageUrl(image?: string) {
  if (!image) {
    return ''
  }

  return getStaticImage({
    path: image,
    preset: presets.SQUARE_LG,
  }) ?? ''
}
</script>
